import { Box, Typography } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';
import { styles } from './FullPageErrorFallback.styles';
import { LandscapeSvg } from './LandscapeSvg';
import React from 'react';
import { ErrorCodes, ErrorMessage } from './fallback.types';

type Props = {
  error: Error;
  resetErrorBoundary: FallbackProps['resetErrorBoundary'];
};

export function FullPageErrorFallback({ error }: Props) {
  const errorMessage = error.message as ErrorMessage;

  const errorCode = ErrorCodes[errorMessage] || '';

  return (
    <Box
      sx={errorCode ? { ...styles.container, ...styles.withErrorCode } : styles.container}
      data-test="fullPageErrorFallback"
    >
      {errorCode ? <Box sx={styles.errorCode}>{errorCode}</Box> : null}

      <LandscapeSvg size="large" />
      <Typography variant="h1" sx={styles.header}>
        {errorMessage === ErrorMessage.NotFound
          ? 'The page you are looking for does not exist'
          : 'Something went wrong'}
      </Typography>
      <Typography variant="h3" color="GrayText" sx={styles.supportText}>
        Try refreshing the page or contact {''}
        <a href="https://support.opengov.com/hc/en-us" target="_blank" rel="noopener noreferrer">
          support
        </a>{' '}
        if the error persists.
      </Typography>
    </Box>
  );
}
